let overlay = null; // overlay reference
let activeTooltip = null; // cloned tooltip reference
let swiper = null; // swiper reference

function showTooltip(targetEl, tooltipEl) {
  if (!tooltipEl) return;
  const targetRect = targetEl.getBoundingClientRect();

  // Clone tooltip
  activeTooltip = tooltipEl.cloneNode(true);
  activeTooltip.classList.add('at-twi-tooltip');
  activeTooltip.classList.remove('at-text-with-icons__tooltip');
  document.body.appendChild(activeTooltip);

  const tooltipRect = activeTooltip.getBoundingClientRect();

  // Default: above target
  let top = targetRect.top - tooltipRect.height - 8;
  let left = targetRect.left + (targetRect.width - tooltipRect.width) / 2;

  // Adjust horizontal if overflowing viewport, ensure 32px min margin
  const margin = 32;
  if (left < margin) {
    left = margin;
  }
  if (left + tooltipRect.width > window.innerWidth - margin) {
    left = window.innerWidth - tooltipRect.width - margin;
  }

  // If tooltip would overflow above, put below
  if (top < 4) {
    top = targetRect.bottom + 8;
  }

  activeTooltip.style.top = `${top + window.scrollY}px`;
  activeTooltip.style.left = `${left + window.scrollX}px`;

  // Stop slider
  if (targetEl.closest('.at-swiper-custom-autorotate')?.swiper) {
    swiper = targetEl.closest('.at-swiper-custom-autorotate');
    swiper.querySelector('.swiper-wrapper').style.animationPlayState = 'paused';
  }

  // Create overlay dynamically
  overlay = document.createElement('div');
  overlay.className = 'at-overlay';
  document.body.classList.add('overflow-hidden');
  overlay.addEventListener('click', hideTooltip);

  // Close on swipe
  let touchStartX = 0;
  let touchStartY = 0;
  overlay.addEventListener('touchstart', (e) => {
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
  }, { passive: true });
  overlay.addEventListener('touchmove', (e) => {
    const dx = Math.abs(e.touches[0].clientX - touchStartX);
    const dy = Math.abs(e.touches[0].clientY - touchStartY);
    if (dx > 10 || dy > 10) hideTooltip();
  }, { passive: true });

  document.body.appendChild(overlay);
}

function hideTooltip() {
  // Start slider
  if (swiper) {
    swiper.querySelector('.swiper-wrapper').style.animationPlayState = 'running';
    swiper = null;
  }

  // Remove cloned tooltip
  if (activeTooltip) {
    document.body.removeChild(activeTooltip);
    activeTooltip = null;
  }

  // Remove overlay
  if (overlay) {
    overlay.removeEventListener('click', hideTooltip);
    document.body.removeChild(overlay);
    overlay = null;
  }
  document.body.classList.remove('overflow-hidden');
}

function bindingEvents(target) {
  Array.from(document.querySelectorAll(target)).forEach((slide) => {
    slide.addEventListener('click', () => {
      // Detect if primary pointer is "fine" (mouse/trackpad) or "coarse" (touch)
      if (window.matchMedia('(pointer: fine)').matches && window.innerWidth > 749) return;
      const tooltip = slide.querySelector('.at-text-with-icons__tooltip');
      showTooltip(slide, tooltip);
    });
  });
}

bindingEvents('.at-text-with-icons__item');


// Add custom autorotate
let count = 0;
const maxRuns = 50;
const interval = setInterval(() => {
  const swipers = document.querySelectorAll('.swiper.at-swiper-custom-autorotate');
  if (swipers[0]?.swiper) {
    Array.from(swipers).forEach((swiperNode) => {
      const swiperRef = swiperNode.swiper;
      // count total
      let total = 0;
      swiperRef.slides.forEach((slide, i) => {
        total += slide.offsetWidth;
        if (i < swiperRef.slides.length) {
          total += swiperRef.params.spaceBetween;
        }
      });
      // clone
      const wrapper = swiperNode.querySelector('.swiper-wrapper');
      const slides = [...wrapper.children];
      slides.forEach((slide) => {
        const clone = slide.cloneNode(true);
        clone.classList.add('clone');
        clone.setAttribute('aria-hidden', 'true');
        wrapper.appendChild(clone);
      });
      // add animation
      const style = document.createElement('style');
      style.textContent = `
        @keyframes scrollSlides-${swiperNode.closest('section').id} {
          0% { transform: translateX(0); }
          100% { transform: translateX(-${total}px); }
        }

        .at-swiper-custom-autorotate .swiper-wrapper.css-autoplay {
          animation: scrollSlides-${swiperNode.closest('section').id} ${swiperNode.getAttribute('data-speed')}s linear infinite;
        }
      `;
      document.head.appendChild(style);
      wrapper.classList.add('css-autoplay');
    });
    bindingEvents('.at-text-with-icons__item.clone');

    clearInterval(interval);
  }
  if (count >= maxRuns) clearInterval(interval);
  count += 1;
}, 250);
